import { MicrosoftXboxIcon } from './MicrosoftXboxIcon';

/**
 * author: Contributors
 * id B7B4ECD9-2895-4E36-88A9-5F3AC5D6C264
 * name microsoft-xbox
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-xbox.svg
 * tags
 * - Social Media 
 * - Brand / Logo 
 * - Gaming / RPG 
 */
export const XboxLiveIcon = MicrosoftXboxIcon;
export default XboxLiveIcon